// Removed Button, Col, Row, Title imports
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
// Added CBButton import
import { CBButton } from '../../core/components/cbd';
import SEO from '../../../components/SEO'
import { useGlobalState } from '../../../store'
import { useLocalization } from '../../../localization'; // Added import
import { loadSyncs } from '../../../utils/fetchData'

const SyncCreateCompletePage = () => {
  const { t } = useLocalization(); // Added hook call
  const [, setLoadingCoreData] = useGlobalState('loadingCoreData')
  const [, setSyncs] = useGlobalState('syncs')
  useEffect(() => {
    setLoadingCoreData(true)
    async function fetchData() {
      const syncs = await loadSyncs()
      setSyncs(syncs)
      setLoadingCoreData(false)
    }
    fetchData()
  }, [])

  return (
    <>
      <SEO title={t('sync.create_complete_seo_title')} /> {/* Localized */}
      {/* Replaced Title with h1/h2 and Tailwind */}
      <h1 className="text-center text-2xl font-semibold mt-10">
        {t('sync.create_complete_title')} {/* Localized */}
      </h1>
      <h2
        className="text-center text-lg text-gray-600 mt-1 mb-10" // Adjusted margins
      >
        {t('sync.create_complete_subtitle')} {/* Localized */}
      </h2>
      {/* Replaced Row/Col with Flexbox */}
      <div className="flex space-x-4"> {/* Use space-x for gutter */}
        <div className="flex-1"> {/* Equivalent to span={12} */}
          <Link to="/dashboard/syncs/new">
             {/* Replaced Button with CBButton */}
            <CBButton className="w-full" type="primary" size="large"> {/* Use w-full for block */}
              {t('sync.add_another_button')} {/* Localized */}
            </CBButton>
          </Link>
        </div>
        <div className="flex-1"> {/* Equivalent to span={12} */}
          <Link to="/dashboard/syncs">
            <CBButton className="w-full" size="large"> {/* Use w-full for block */}
              {t('sync.all_done_button')} {/* Localized */}
            </CBButton>
          </Link>
        </div>
      </div>
    </>
  )
}

export default SyncCreateCompletePage
